/** @format */

export const citiesDefaultCoordinates: Record<string, { latitude: number; longitude: number }> = {
  Bologna: { latitude: 44.4949, longitude: 11.3309 },
  Bordeaux: { latitude: 44.8378, longitude: -0.5792 },
  Burdeos: { latitude: 44.8378, longitude: -0.5792 },
  Bordò: { latitude: 44.8378, longitude: -0.5792 },
  Como: { latitude: 45.808, longitude: 9.0851 },
  Ferrara: { latitude: 44.8378, longitude: 11.6194 },
  Florence: { latitude: 43.7696, longitude: 11.2558 },
  Firenze: { latitude: 43.7696, longitude: 11.2558 },
  Florencia: { latitude: 43.7696, longitude: 11.2558 },
  Lille: { latitude: 50.6292, longitude: 3.0573 },
  Lilla: { latitude: 50.6292, longitude: 3.0573 },
  Rijsel: { latitude: 50.6292, longitude: 3.0573 },
  Lisbon: { latitude: 38.7223, longitude: -9.1393 },
  Lisboa: { latitude: 38.7223, longitude: -9.1393 },
  Lisbona: { latitude: 38.7223, longitude: -9.1393 },
  Lisbonne: { latitude: 38.7223, longitude: -9.1393 },
  Lyon: { latitude: 45.764, longitude: 4.8357 },
  Lione: { latitude: 45.764, longitude: 4.8357 },
  Madrid: { latitude: 40.4168, longitude: -3.7038 },
  Madrit: { latitude: 40.4168, longitude: -3.7038 },
  Milan: { latitude: 45.4642, longitude: 9.19 },
  Milano: { latitude: 45.4642, longitude: 9.19 },
  Milán: { latitude: 45.4642, longitude: 9.19 },
  Montpellier: { latitude: 43.6108, longitude: 3.8767 },
  Monpellier: { latitude: 43.6108, longitude: 3.8767 },
  Padua: { latitude: 45.4064, longitude: 11.8768 },
  Padova: { latitude: 45.4064, longitude: 11.8768 },
  Padoue: { latitude: 45.4064, longitude: 11.8768 },
  Paris: { latitude: 48.8566, longitude: 2.3522 },
  Parigi: { latitude: 48.8566, longitude: 2.3522 },
  París: { latitude: 48.8566, longitude: 2.3522 },
  Parma: { latitude: 44.8015, longitude: 10.3279 },
  Rome: { latitude: 41.9028, longitude: 12.4964 },
  Roma: { latitude: 41.9028, longitude: 12.4964 },
  Siena: { latitude: 43.3188, longitude: 11.3309 },
  Toulouse: { latitude: 43.6047, longitude: 1.4442 },
  Tolosa: { latitude: 43.6047, longitude: 1.4442 },
  Trento: { latitude: 46.0748, longitude: 11.1217 },
  Trieste: { latitude: 45.6495, longitude: 13.7768 },
  Turin: { latitude: 45.0703, longitude: 7.6869 },
  Torino: { latitude: 45.0703, longitude: 7.6869 },
  Turín: { latitude: 45.0703, longitude: 7.6869 },
  Venice: { latitude: 45.4408, longitude: 12.3155 },
  Venezia: { latitude: 45.4408, longitude: 12.3155 },
  Venise: { latitude: 45.4408, longitude: 12.3155 },
  Venecia: { latitude: 45.4408, longitude: 12.3155 },
};
